import React from "react";
import {greyishBlue50, greyishBlue100} from "assets/jss/main";

export default function TabButton({ tab, isActive, onClick, selectedCount }) {
    return (
        <button
            key={tab.id}
            onClick={onClick}
            style={{
                display: "flex", alignItems: "center", gap: "8px",
                padding: "8px 16px", borderRadius: "999px",
                border: isActive ? "none" : `1px solid ${greyishBlue100}`,
                backgroundColor: isActive ? "#4338ca" : "#ffffff",
                color: isActive ? "#ffffff" : "#6b7280",
                fontSize: "13px", fontWeight: "500",
                cursor: "pointer", fontFamily: "inherit",
                transition: "all 0.15s ease",
            }}
        >
            <span style={{color: isActive ? "#ffffff" : "#9ca3af"}}>
                {tab.icon}
            </span>
            {tab.label}
            <span style={{
                backgroundColor: isActive ? "rgba(255,255,255,0.25)" : greyishBlue50,
                color: isActive ? "#ffffff" : "#6b7280",
                borderRadius: "999px",
                padding: "1px 7px",
                fontSize: "12px",
                fontWeight: "600",
            }}>
             {selectedCount}
            </span>
        </button>
    );
}
